<template>
  <div class="tac" v-if="field">
    <div class="tac-button">
      <template v-if="data.checkboxmode == 'normal'">
        <Checkbox 
          :inputId="`${step?.name}[${data?.element_details?.name}]${data?.id}`"
          :name="`${step.name}[${data.element_details.name}]`"
          :invalid="field?.invalid ?? false"
          v-model="field.value"
          :value="1"
          @change="onInput"
        />
      </template>
      <ToggleSwitch v-else
        :inputId="`${step?.name}[${data?.element_details?.name}]${data?.id}`"
        :name="`${step.name}[${data.element_details.name}]`"
        :trueValue="1"
        :falseValue="null"
        :invalid="field?.invalid ?? null"
        v-model="field.value"
      />
    </div>
    <div class="tac-text">
      <template v-if="data.html_text">
        <label :for="`${step.name}[${data.element_details.name}]` + data.id" v-html="data.html_text"></label>
      </template>
      <template v-else>
        <label :for="`${step.name}[${data.element_details.name}]` + data.id" v-html="data.label"></label>
      </template>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['update:modelValue', 'update:slideForward']);

const props = defineProps({
  data: Object,
  field: Object,
  step: Object,
})

// function handleUpdate(val) {
//     emit('update:modelValue', val);
//     if (!!props.data.jump) {
//         emit('update:slideForward');
//     }
// }

</script>
